import {
  Breadcrumbs,
  Theme,
  createStyles,
  makeStyles,
} from '@material-ui/core';
import * as React from 'react';
import { NonHoverBackground } from 'src/theme/colors';
import { ForwardIcon } from '../Icons';
import { BreadCrumbItem } from '../UI/BreadCrumbBase';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    breadcrumbs: {
      height: 32,
      borderRadius: 64,
      backgroundColor: NonHoverBackground,
      width: 'fit-content',
      padding: theme.spacing(0, 1.5),
    },
  }),
);

export const InvoiceNotificationDetailsBreadcrumbs: React.FC<{
  invoiceNumber: string;
}> = ({ invoiceNumber }) => {
  const classes = useStyles();
  const nodes = [
    { label: 'Invoices', path: '/invoices' },
    { label: invoiceNumber },
  ];

  return (
    <Breadcrumbs
      classes={{
        ol: classes.breadcrumbs,
      }}
      separator={<ForwardIcon style={{ fontSize: 9 }} />}
    >
      {nodes.map((node) => (
        <BreadCrumbItem label={node.label} path={node.path} key={node.label}>
          {node.label}
        </BreadCrumbItem>
      ))}
    </Breadcrumbs>
  );
};
